import { IPackage } from "dto/IPackage";
import { IAttachment } from "dto/IAttachment";
import { ItemKind } from "dto/IKindItems";
import { generateMockPackage } from "modules/packageModule/mocked_packge";
import {
  IAcceptanceSignItem,
  getReceivedApi,
  getNotificationsApi,
} from "api/acceptanceService";

/**
 * Adapter korzenia „Akceptacja i Podpis" do formatu listy „Przychodzące" (IPackage).
 * Dane pochodzą z BE (AcceptanceController); obiekty trafiają do skrzynek w wyniku
 * automatycznego przekazania przez workflow. Skrzynki „Otrzymane" i „Powiadomienia"
 * reużywają komponentu listy Przychodzące, więc mapujemy pozycje na IPackage.
 */

/** IPackage z doklejoną pozycją skrzynki — panel prawy rozpoznaje po niej typ dokumentu. */
export type IAcceptancePackage = IPackage & { AcceptanceItem: IAcceptanceSignItem };

const toPackage = (item: IAcceptanceSignItem): IAcceptancePackage => {
  const hasFile = !!item.FileUri && !!item.EncryptionKeyId;
  // Plik przekazany do akceptacji niesiemy jako pojedynczy załącznik IPackage —
  // panel prawy odszyfruje go i pokaże w PDFViewer. ownerKind do GET /file
  // (Kind) — do potwierdzenia po stronie BE dla plików akceptacji.
  const attachment = {
    Id: item.DocumentId || item.Id,
    Uri: item.FileUri,
    EncryptionKeyId: item.EncryptionKeyId,
    FileName: item.FileName ?? "dokument.pdf",
    Kind: ItemKind.CaseFile,
    ContentType: "application/pdf",
  } as unknown as IAttachment;

  return {
    ...generateMockPackage(),
    Id: item.Id,
    Sender: item.Sender ?? "",
    S1: item.Title ?? "",
    S2: item.Subject ?? "",
    SendDate: new Date(item.CreatedAt),
    ReceiveDate: item.ReceivedAt ? new Date(item.ReceivedAt) : new Date(item.CreatedAt),
    Unread: item.Status === "Pending",
    AttachmentsCount: hasFile ? 1 : 0,
    EncryptionKeyId: item.EncryptionKeyId ?? null,
    ObjectKeys: item.ObjectKeys ?? [],
    Attachments: hasFile ? [attachment] : [],
    Kind: 1,
    AcceptanceItem: item,
  };
};

export const getAcceptanceReceivedPackages = async (): Promise<IPackage[]> =>
  (await getReceivedApi()).map(toPackage);

export const getAcceptanceCcPackages = async (): Promise<IPackage[]> =>
  (await getNotificationsApi()).map(toPackage);
